import React from "react";
import {
  CasingImpactEdit,
  EngineeringstudyEdit,
  Equipments,
  ENR,
  Market,
  Behaviour,
} from "./Impact/Index.js";

export default function ImpactEdit({ apiData, params, closeModal, category }) {
  const categoryType = {
    engineeringstudy: EngineeringstudyEdit,
    casing: CasingImpactEdit,
    equipments: Equipments,
    renewables: ENR,
    contracts: Market,
    behaviour: Behaviour,
  };

  const SelectedCategoryType = categoryType[category];
  return (
    <SelectedCategoryType
      apiData={apiData}
      params={params}
      closeModal={closeModal}
    />
  );
}
